import React, { useContext, useEffect, useMemo, useState, useRef } from 'react';
import { SiderParentLabel } from ".."
import { SkeletonLoader, LazyLoadingWithPagination } from "components/shared";
import { TaskService } from "services/http";
import { useHistory } from 'react-router';
import utils, { INTERVENTION_SOCKET_STATUS, INTERVENTION_STATUS, INTERVENTION_STEP } from "utils";
import { TaskItem } from "components/layout/sidebar/tasks-part/task-item";
import { SocketContext } from 'services/';
import { MasterPageContext } from 'components/pages';

export const TaskSide = (props) => {

    /**
    * This allows to filter the tasks by status INIT in order to prevent the replication on state
    * This is temporary fix, to be dealed from backend service api
    * @param {Array} tasks set of global tasks 
    * @returns Array of tasks with status INIT
    */
    const filterNewTasks = (tasks) => { return tasks.filter(item => item.status.statusId === INTERVENTION_STATUS.INITIATED); }
    const history = useHistory();
    const [tasks, setTasks] = useState(filterNewTasks(props.data.interventions));
    const socketContext = useContext(SocketContext);
    const [currentTask, setCurrentTask] = useState();
    const [callback, setCallback] = useState();
    let tasksSubscription;
    //On going Tasks
    const [onGoingTasksLoading, setOnGoingTasksLoading] = React.useState(false);
    const [onGoingTasks, setOngoingTasks] = React.useState([]);

    useEffect(() => {
        //SUBSCRIBE TO THE INTERVENTION TOPIC
        socketContext.getStompClient().then((result) => {
            tasksSubscription = result.subscribe(`${process.env.REACT_APP_SOCKET_TASK_TOPIC}`, callbackRecieve);
        });
        //UNSEBSCRIBE INTERVENTION TOPIC
        return () => { tasksSubscription && tasksSubscription.unsubscribe() }
    }, []);

    /**
     * Fetching on going tasks from inbox folder
     */
    React.useEffect(() => {
        setOnGoingTasksLoading(true);
        TaskService.getOngoingTasks().then(response => {
            let onGoingtasks = response.result.interventions;
            setTasks(tasks.concat(onGoingtasks));
            setOngoingTasks(onGoingtasks);
        }, error => {
            alert(JSON.stringify(error));
        }).finally(() => { setOnGoingTasksLoading(false) });
    }, []);

     /**
     * Fetching Transfered tasks from Trans folder
     */
      React.useEffect(() => {
        TaskService.getTransferedTasks().then(response => {
            let transferedTasks = response.result.interventions;
            setTasks(tasks.concat(transferedTasks));
            //setTransferredTasks(transferedTasks);
        }, error => {
            alert(JSON.stringify(error));
        });
    }, []);

    //ON RECIEVE CALLBACK BROADCAST
    const callbackRecieve = (data) => {
        let payload = JSON.parse(data.body);
        setCallback(payload);
    }

    //DISPATCH BRAODCASTED PAYLOAD FROM INTERVENTION TOPIC
    useEffect(() => {
        const payload = callback;
        (payload && payload.type.includes(`intervention`)) &&
            onTendDispatchedTask(payload);
    }, [callback]);

    //SYNCRONIZE LAZY FETCHED INTERVENTIONS FROM HOC
    useEffect(() => {
        setTasks(onGoingTasks.concat(filterNewTasks(props.data.interventions)));
    }, [props.data.interventions]);

    //ON DEAL TASK ACTION
    const onDealTask = (e, task) => {
        utils.pushURLSearchParams(history, "task", JSON.stringify(task));
        setCurrentTask(task);
        e.preventDefault();
    }

    const notifyURLSearchParams = (task) => {
        utils.pushURLSearchParams(history, "task", JSON.stringify(task));
    }

    //TENDING BROADCASTED TASK IN THE SET
    const onTendDispatchedTask = (dispatchedTask) => {
        if (dispatchedTask) {
            let dispatchedTaskId = dispatchedTask?.intervention.interventionId;
            switch (dispatchedTask.type) {
                case INTERVENTION_SOCKET_STATUS.NEW_INTERVENTION_STATUS: {
                    //PUSHING NEW INTERVENTION
                    if (tasks?.filter((task) => task.interventionId == dispatchedTaskId).length < 1) {
                        setTasks((tasks) => [...tasks, dispatchedTask.intervention]);
                        //tasks.splice(0, 0, dispatchedTask.intervention);
                        utils.playAudioNotification();
                    }
                    break;
                }
                case INTERVENTION_SOCKET_STATUS.UPDATED_INTERVENTION_STATUS: {
                    //UPDATING INTERVENTION
                    tasks && setTasks(
                        tasks.map((item) => {
                            return item.interventionId === dispatchedTaskId ? dispatchedTask.intervention : item;
                        }));

                    //NOTIFY FOR UPDATED TASK STATUS
                    currentTask?.interventionId == dispatchedTaskId && notifyURLSearchParams(dispatchedTask.intervention);
                    break;
                }
                case INTERVENTION_SOCKET_STATUS.REMOVED_INTERVENTION_STATUS: {
                    //DELETING INTERVENTION
                    tasks && setTasks((tasks) => tasks.filter((task) => task.interventionId !== dispatchedTaskId));
                    if (currentTask?.interventionId == dispatchedTaskId) {
                        history.push(`/tasks`)
                        setCurrentTask(null);
                    };
                    break;
                }
                case INTERVENTION_SOCKET_STATUS.UPDATED_LAST_SEEN: {
                    //NOTIFY FOR UPDATED LAST SEEN
                    currentTask?.interventionId == dispatchedTaskId && notifyURLSearchParams(dispatchedTask.intervention);
                    break;
                }
                default: {
                    break;
                }
            }

        }
    }


    return (
        <>
            {/* OnGoing Intervention Section */}
            <SiderParentLabel icon="bi bi-inboxes-fill" label={`Ongoing Tasks ${tasks?.length ? `(${utils.filterArrayBasedStatus(tasks, INTERVENTION_STATUS.INITIATED, false).length})` : ''}`} />
            <div className="overflow-auto" style={{ height: window.innerHeight - 100 }}>
                {
                    onGoingTasksLoading ? <SkeletonLoader factor={3} /> :
                        utils.filterArrayBasedStatus(tasks, INTERVENTION_STATUS.INITIATED, false).length ? utils.filterArrayBasedStatus(tasks, INTERVENTION_STATUS.INITIATED, false).map((task) => {
                            return <TaskItem
                                title={`${task.client.firstname} ${task.client.lastname}`}
                                author={task.lastMessage.direction === "outgoing" ? "Agent: " : null}
                                direction={task.lastMessage.direction}
                                message={task.lastMessage}
                                taskId={task.interventionId}
                                attachement={task.lastMessage?.withAttachment === 1}
                                sourceIcon={utils.guessSourceIcon(task?.source.sourceId)}
                                avatar={task.client.profilePic}
                                time={new Date(task.creationDate).toLocaleString()}
                                dealActionTask={(e) => onDealTask(e, task)}
                                nextStatus={task.nextStatus}
                                intervention={task}
                            />
                        }) : utils.NoItemsTemplate()
                }

                {/* Transfered Intervention Section */}
                {
                    utils.filterArrayBasedStepChrnology(tasks, INTERVENTION_STEP.TRANSFERED_STEP, true).length ?
                        <SiderParentLabel icon="bi bi-arrow-left-right" label={`Transfered Tasks ${tasks?.length ? `(${utils.filterArrayBasedStepChrnology(tasks, INTERVENTION_STEP.TRANSFERED_STEP, true).length})` : ''}`} className="mt-3" /> : ``
                }
                {
                    utils.filterArrayBasedStepChrnology(tasks, INTERVENTION_STEP.TRANSFERED_STEP, true).map((task) => {
                        return <TaskItem
                            title={`${task.client.firstname} ${task.client.lastname}`}
                            author={task.lastMessage.direction === "outgoing" ? "Agent: " : null}
                            direction={task.lastMessage.direction}
                            message={task.lastMessage}
                            taskId={task.interventionId}
                            attachement={task.lastMessage?.withAttachment === 1}
                            sourceIcon={utils.guessSourceIcon(task?.source.sourceId)}
                            avatar={task.client.profilePic}
                            time={new Date(task.creationDate).toLocaleString()}
                            dealActionTask={(e) => onDealTask(e, task)}
                            nextStatus={task.nextStatus}
                            intervention={task}
                        />
                    })
                }

                {/* New Intervention Section */}
                {
                    utils.filterArrayBasedStatus(tasks, INTERVENTION_STATUS.INITIATED, true).length ?
                        <SiderParentLabel icon="bi bi-inboxes" label={`New Tasks ${tasks?.length ? `(${utils.filterArrayBasedStatus(tasks, INTERVENTION_STATUS.INITIATED, true).length})` : ''}`} className="mt-3" /> : ``
                }
                {
                    utils.filterArrayBasedStatus(tasks, INTERVENTION_STATUS.INITIATED, true).map((task) => {
                        return <TaskItem
                            title={`${task.client.firstname} ${task.client.lastname}`}
                            author={task.lastMessage.direction === "outgoing" ? "Agent: " : null}
                            direction={task.lastMessage.direction}
                            message={task.lastMessage}
                            taskId={task.interventionId}
                            attachement={task.lastMessage?.withAttachment === 1}
                            sourceIcon={utils.guessSourceIcon(task?.source.sourceId)}
                            avatar={task.client.profilePic}
                            time={new Date(task.creationDate).toLocaleString()}
                            dealActionTask={(e) => onDealTask(e, task)}
                            nextStatus={task.nextStatus}
                            intervention={task}
                        />
                    })
                }
                {
                    props.children
                }
            </div>
        </>
    );
}

export const TaskSideHoc = (props) => {
    const masterContext = useContext(MasterPageContext);
    const [refresh, setRefresh] = useState(0);

    useEffect(() => {
        if (masterContext.refreshTaskSideBasedStatus) setRefresh(refresh + 1);
    }, [masterContext.refreshTaskSideBasedStatus]);

    const TaskSideHocMemo = useMemo(() => LazyLoadingWithPagination(TaskSide, TaskService.getLazyTasks, { pageIndex: 0 }, "interventions", <SkeletonLoader factor={6} />)(props), [refresh]);
    return <TaskSideHocMemo />
}